import { render, staticRenderFns } from "./FixedExpenseTypeAddEditView.vue?vue&type=template&id=c0ad5ed4&scoped=true&"
import script from "./FixedExpenseTypeAddEditView.vue?vue&type=script&lang=js&"
export * from "./FixedExpenseTypeAddEditView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ad5ed4",
  null
  
)

export default component.exports